import { __decorate } from "tslib";
//NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
//SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ToolEditModel, } from "@/store/models/tools/ToolUpdate";
import toolModule from "@/store/modules/tool.module";
let ViewTool = /** @class */ (() => {
    let ViewTool = class ViewTool extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //DATA
            this.title = "ViewTool";
            this.ctaButtons = [
                {
                    routeName: "Tools",
                },
            ];
            this.items = [
                {
                    text: "Tools",
                },
                {
                    text: "View Tool",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedTool = new ToolEditModel();
        }
        cancelTool() {
            this.$router.push({ name: "Tools" });
        }
        //CRUD
        editTool(toolId) {
            this.$router.push({ name: "UpdateTool", params: { id: toolId } });
        }
        //LIFECYCLE
        created() {
            var toolId = Guid.parse(this.$route.params.id);
            toolModule.GetToolDetailById(toolId).then((response) => {
                this.pageIsLoading = false;
                this.selectedTool = new ToolEditModel();
                this.selectedTool = {
                    id: response.updateTool.id,
                    name: response.updateTool.name,
                    latestVersion: response.updateTool.latestVersion,
                    discription: response.updateTool.discription,
                    licence: response.updateTool.licence,
                    price: response.updateTool.price,
                    url: response.updateTool.url,
                    status: response.updateTool.status,
                    userLimits: response.updateTool.userLimits,
                };
            });
        }
    };
    ViewTool = __decorate([
        Component({
            name: "ViewTool",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], ViewTool);
    return ViewTool;
})();
export default ViewTool;
